import React from 'react'
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount'
import Tooltip from '@material-ui/core/Tooltip';
import qqImg from '../static/img/qq.png'

const styles = {
    root: {
        width: 35,
        height: 35,
        overflow: 'hidden',
        position: 'fixed',
        right: 0,
        top: '30%',
        marginTop: -25,
        zIndex: 999998,
        minHeight:30,
        backgroundColor: '#828282',
        borderRadius: '5px 0 0 5px'
    },
    tooltip: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    img: {
        width: 24,
        height: 24
    },
    a: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 5
    }
}
export default class QQ extends React.Component {
    render() {
        const {value} = this.props;
        return(
            <div style={styles.root}>
                <Tooltip id="qq" title={<div style={styles.tooltip}><SupervisorAccountIcon />客服QQ：{value}</div>} placement="left">
                    <a href={`http://wpa.qq.com/msgrd?v=3&uin=${value}&site=qq&menu=yes`} target="_blank" style={styles.a}>
                        <img src={qqImg} alt="客服" style={styles.img}/>
                    </a>
                </Tooltip>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/uis/qq.js